export default "__VITE_ASSET__3d6b74cb__"